import React from 'react';
import Settings from '../settings';

export default function loadLocale(resources) {
    resources['or'] = "O";
    resources['hi'] = "Salve";
    resources['view-user'] = "Visualizza utente";
    resources['user-profile'] = "Il tuo Profilo";
    resources['welcome-message'] = "Benvenuti al portale " + Settings['project-name'];
    resources['welcome-message-desc'] = "";
    resources['months'] = ['GEN', 'FEB', 'MAR', 'APR', 'MAG', 'GIU', 'LUG', 'AGO', 'SET', 'OTT', 'NOV', 'DIC'];
    resources['at-time'] = "alle";
    resources['days'] = "Giorni";
    resources['hours'] = "Ore";
    resources['minutes'] = "Minuti";
    resources['seconds'] = "Secondi";
    resources["awesome"] = "Fantastico";
    resources["public"] = "Pubblico";
    resources["private"] = "Privato";
    resources["language"] = "Lingua";
    resources["my-account"] = "Il Mio Account";
    resources["my-account-desc"] = "";
    resources["insert"] = "Inserisci";
    resources["update"] = "Aggiorna";
    resources["edit"] = "Modifica";
    resources["remove"] = "Rimuovi";
    resources["hello"] = "Salve";
    resources["id"] = "Id";
    resources["title"] = "Titolo";
    resources["value"] = "Valore";
    resources["name"] = "Nome";
    resources["surname"] = "Cognome";
    resources["email"] = "e-Mail";
    resources["phone"] = "Telefono";
    resources["mobile-phone"] = "Mobile";
    resources["published"] = "Pubblico";
    resources["your-id-is"] = "Il tuo Id è ";
    resources["item-id-is"] = "L'ID di questa scheda è ";
    resources["item-id"] = "ID Scheda";
    resources["password"] = "Password";
    resources["created-at"] = "Creato";
    resources["updated-at"] = "Aggiornato";
    resources["size"] = "Dimensione";
    resources["access-to-portal"] = "Accedi al Portale " + Settings["project-name"];
    resources["description"] = "Descrizione";
    resources["note"] = "Note";
    resources["internal-notes"] = "Note Interne";
    resources["company"] = "Azienda";
    resources["quantity"] = "Quantità";
    resources["price"] = "Prezzo";
    resources["free"] = "Gratis";
    resources["availability"] = "Disponibilità";
    resources["category"] = "Categoria";
    resources["date-time"] = "Data e Ora";
    resources["time"] = "Ora";
    resources["ip-address"] = "Indirizzo IP";
    resources["delete"] = "Elimina";
    resources["create"] = "Crea";
    resources["cancel"] = "Annulla";
    resources["yes"] = "Sì";
    resources["no"] = "No";
    resources["none"] = "Nessuno";
    resources["submit"] = "Invia";
    resources["no-items-in-the-list"] = "Non ci sono elementi da visualizzare.";
    resources["no-special-characters-only-comma"] = "Caratteri speciali non consentiti, solo spazi, trattini e virgole.";
    resources["from"] = "Da";
    resources["to"] = "A";
    resources["save"] = "Salva";
    resources["datetime"] = "Data & Ora";
    resources["timezone"] = "Fuso Orario";
    resources["document"] = "Documento";

    resources["home"] = "Home";
    resources["user"] = "Utente";
    resources["users"] = "Utenti";
    resources["role"] = "Ruolo";
    resources["roles"] = "Ruoli";
    resources["permission"] = "Permission";
    resources["permissions"] = "Permissions";
    resources["admin"] = "Admin";
    resources["assets"] = "Assets";
    resources["logs"] = "Logs";

    resources["store"] = "Azienda";
    resources["stores"] = "Aziende";
    resources["shop"] = "Negozio";
    resources["locale"] = "Ambiente";
    resources["shop-items"] = "Shop Items";
    resources["shop-item"] = "Shop Item";
    // resources["enoteca-item"] = "Enoteca Item";
    // resources["enoteca-items"] = "Enoteca Items";
        
    resources["saving"] = "Salvataggio...";
    resources["close"] = "Chiudi";
    resources["create-item-first"] = "Crea la scheda prima di trasferire l'immagine.";
    resources["confirm-delete"] = "Sei sicuro di volere eliminare questa scheda?";
    resources["confirm-delete-heading"] = "Elimina questa scheda";
    resources["attach-files-after-creation"] = "I file possono essere associati dopo aver creato una nuova scheda.";

    resources["contacts"] = "Contatti";
    resources["contact"] = "Contatto";
    resources["contact-name"] = "Nome Contatto";
    resources["locations"] = "Locali";
    resources["location"] = "Locale";
    resources["address"] = "Indirizzo";
    resources["post-code"] = "CAP";
    resources["city"] = "Città";
    resources["county"] = "Contea";
    resources["country"] = "Nazione";
    
    resources["video-streams"] = "Video";
    resources["team-members"] = "Team";
    
    resources["tables"] = "Tabelle";
    resources["social-type"] = "Tipo Social";
    resources["social-types"] = "Tipi Social";
    resources["social"] = "Social";
    resources["socials"] = "Social";
    resources["stream"] = "Stream";
    resources["streams"] = "Stream";
    resources["stream-type"] = "Sorgente Stream";
    resources["stream-types"] = "Sorgenti Stream";
    resources["report"] = "Report";
    resources["reports"] = "Report";

    resources["assets"] = "Assets";
    resources["asset"] = "Asset";
    resources["version"] = "Versione";

    resources["asset-types"] = "Asset Types";
    resources["asset-type"] = "Asset Type";
    resources["type"] = "Tipo";
    resources["required"] = "Obbligatorio";
    resources["required-field"] = "Campo obbligatorio";

    resources["week-days-short"] = ["Lun","Mar","Mer","Gio","Ven","Sab","Dom"];
    resources["enable-edit"] = "Abilita Modifiche";
    resources["disable-edit"] = "Disabilita Modifiche";
    resources["modules"] = "Moduli";
    resources["module"] = "Modulo";
    resources["too-short"] = "Troppo breve";
    resources["too-long"] = "Troppo lungo";
    resources["params"] = "Parametri";
    resources["invalid-url"] = "URL Non Valido";
    resources["max-255-chars"] = "Max 255 caratteri";
    resources["fill-field"] = "Compila il campo";
    resources["hidden-by-user"] = "Nascosto dall'utente";
    resources["premium-feature"] = <small>Scopri con un account premium.</small>;
    resources["subdomain"] = "Sottodominio";
    resources["setup"] = "Imposta";
    resources["localization-options"] = "Opzioni di Localizzazione"

    resources["shop-not-active"] = "Il tuo store non è ancora stato attivato.";
    resources["shop-disabled"] = "Il tuo store è stato disabilitato.";
    resources["no-role"] = "Non hai nessun servizio associato a questo account.";

    resources["recent-touches"] = "Contatti Recenti";
    resources["all-touches"] = "Mostra Tutti";
    resources["newsletter-allowed"] = "Newsletter consentita.";
}
